/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProviderEmissions } from './ProviderEmissions';
import {
    ProviderEmissionsFromJSON,
    ProviderEmissionsFromJSONTyped,
    ProviderEmissionsToJSON,
    ProviderEmissionsToJSONTyped,
} from './ProviderEmissions';

/**
 * Serializer for emissions data grouped by quarter.
 * @export
 * @interface QuarterEmissions
 */
export interface QuarterEmissions {
    /**
     * Quarter description (e.g., '2024-Q1')
     * @type {string}
     * @memberof QuarterEmissions
     */
    quarter: string;
    /**
     * Start date of the quarter
     * @type {Date}
     * @memberof QuarterEmissions
     */
    startDate: Date;
    /**
     * End date of the quarter
     * @type {Date}
     * @memberof QuarterEmissions
     */
    endDate: Date;
    /**
     * Emissions data for each provider
     * @type {Array<ProviderEmissions>}
     * @memberof QuarterEmissions
     */
    data: Array<ProviderEmissions>;
}

/**
 * Check if a given object implements the QuarterEmissions interface.
 */
export function instanceOfQuarterEmissions(value: object): value is QuarterEmissions {
    if (!('quarter' in value) || value['quarter'] === undefined) return false;
    if ((!('startDate' in (value as Record<string, any>)) && !('start_date' in (value as Record<string, any>))) || ((value as Record<string, any>)['startDate'] === undefined && (value as Record<string, any>)['start_date'] === undefined)) return false;
    if ((!('endDate' in (value as Record<string, any>)) && !('end_date' in (value as Record<string, any>))) || ((value as Record<string, any>)['endDate'] === undefined && (value as Record<string, any>)['end_date'] === undefined)) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function QuarterEmissionsFromJSON(json: any): QuarterEmissions {
    return QuarterEmissionsFromJSONTyped(json, false);
}

export function QuarterEmissionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuarterEmissions {
    if (json == null) {
        return json;
    }
    return {
        
        'quarter': json['quarter'],
        'startDate': (new Date(json['start_date'])),
        'endDate': (new Date(json['end_date'])),
        'data': ((json['data'] as Array<any>).map(ProviderEmissionsFromJSON)),
    };
}

export function QuarterEmissionsToJSON(json: any): QuarterEmissions {
    return QuarterEmissionsToJSONTyped(json, false);
}

export function QuarterEmissionsToJSONTyped(value?: QuarterEmissions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'quarter': value['quarter'],
        'start_date': value['startDate'].toISOString().substring(0,10),
        'end_date': value['endDate'].toISOString().substring(0,10),
        'data': ((value['data'] as Array<any>).map(ProviderEmissionsToJSON)),
    };
}

